module.exports = __webpack_public_path__ + "static/media/hrithik.95c5ee59.jpg";